import React from 'react'
import { validations, validateCase as vCase } from 'core/validate'

export const validateOriginalForm = (values) => {
  let errors = {}

  validations(values, 'title', [vCase.require], errors)
  validations(values, 'vendorCode', [vCase.require], errors)
  validations(values, 'companyCode', [vCase.require], errors)
  validations(values, 'typeOfBond', [vCase.require], errors)

  if (values.typeOfBond === 'other') {
    validations(values, 'otherTypeOfBond', [vCase.require], errors)
  }

  validations(values, 'amount', [vCase.require], errors)
  validations(values, 'bankGuaranteeNumber', [vCase.require, vCase.maxLength50], errors)
  validations(values, 'bankOwner', [vCase.require], errors)
  validations(values, 'startDate', [vCase.require], errors)
  
  if (values.noExpire === false) {
    validations(values, 'dueDate', [vCase.require], errors)
  }
  if (values.dueDate && (values.dueDate < values.startDate)) {
    errors.dueDate = 'Due date must be greater than Start date!'
  }
  validations(values, 'job', [vCase.require], errors)
  
  if (values.location === 'bank') {
    validations(values, 'depositAtBank', [vCase.require], errors)
    validations(values, 'depositDate', [vCase.require], errors)
    validations(values, 'depositor', [vCase.require], errors)
  }

  // validations(values, 'projectManagerUser', [vCase.require], errors)

  // if ((values.vendorContacts || []).length === 0) {
  //   errors.vendorContactsErrorMessage = 'Minimum 1 user of vendor contact required!'
  // }

  if ((values.BG01 || []).length === 0 && (values.attachment01 || []).length === 0) {
    errors.BG01 = 'Require!'
  }
  
  return errors 
}

export const validateRequestForm = (values) => {
  let errors = {}

  validations(values, 'companyCode', [vCase.require], errors)
  validations(values, 'vendorCode', [vCase.require], errors)

  if ((values.bgRelates || []).length === 0) {
    errors.bgRelatedSelect = 'Require! Minimum 1 row of bank guarantee related '
  }

  if (values.requestType === 'change') {
    if ((values.newBankGuarantees || []).length === 0) {
      errors.newBgMessage = 'Require! Minimum 1 row of new bank guarantee data '
    } else {
      // if (values.typeOfBond === 'advancePayment') {
      //   var newBgsAmount = 0
      //   values.newBankGuarantees.forEach(x => { newBgsAmount += Number(x.amount) })

      //   if (newBgsAmount < values.loadAmount) {
      //     errors.newBgMessage = 'Please check your data. Total New BG can’t be less than loan.'
      //   }
      // }
    }
  }

  validations(values, 'title', [vCase.require], errors)
  if (values.requestType === 'change') {
    validations(values, 'reason', [vCase.require], errors)
  }
  validations(values, 'requesterUser', [vCase.require], errors)
  validations(values, 'projectManagerUser', [vCase.require], errors)

  if ((values.vendorContacts || []).length === 0) {
    errors.vendorContactsErrorMessage = 'Minimum 1 user of vendor contact required!'
  }

  if ((values.BG04 || []).length === 0 && (values.attachment04 || []).length === 0) {
    errors.BG04 = 'Require!'
  }

  return errors
}